import { call, put, select } from 'redux-saga/effects';
import { urls } from '../../../common/urls';
import { getHttp, getHttpwithtoken, postHttpwithtoken } from '../../../common/ApiCall';
import {
  uploadFileFailure,
  uploadFileLoading,
  uploadFileSuccess,
} from '../../ducks/AttachmentSlice';

// Upload File Handler
export function* handlerUploadFile(action: any): Generator<any, void, any> {
  try {
    yield put(uploadFileLoading());
    const response: any = yield call(postHttpwithtoken, `${urls.baseURL}${urls.uploadfile}`, action.payload);
    
    if (response.success) {
      yield put(uploadFileSuccess(response.data));
    } else {
      yield put(uploadFileFailure(response.message || 'File upload failed'));
    }
  } catch (error: any) {
    yield put(uploadFileFailure(error.message || 'File upload failed'));
  }
}
